// extracted by mini-css-extract-plugin
export var childrenContainer = "_44-0";
export var virtualScrollArea = "_44-1";